export enum BizType {
  MYDATA_CORP = 'MYDATA_CORP',
  MYDATA_PROVIDER = 'MYDATA_PROVIDER',
  SET4 = 'SET4',
  EDOC = 'EDOC'
}

export const BIZ_TYPE = {
  [BizType.MYDATA_CORP]: '마이데이터 통합인증 서비스',
  [BizType.MYDATA_PROVIDER]: '마이데이터제공자 서비스',
  [BizType.SET4]: '인증 서비스',
  [BizType.EDOC]: '전자문서 서비스'
} as const;

export const BIZ_TIARA_TYPE = {
  [BizType.MYDATA_CORP]: '마이데이터',
  [BizType.MYDATA_PROVIDER]: '마이데이터',
  [BizType.SET4]: '인증',
  [BizType.EDOC]: '전자문서'
} as const;

export const ALL_BIZ_TYPES = Object.values(BizType);
export const STATS_REPORT_BIZ_TYPES = [BizType.SET4, BizType.EDOC];
